import React from "react";
import StoryCarousel from "../StoryCarousel";

function Publication() {
  return (
    <StoryCarousel
      id="home-stories-title"
      eyebrow="Stories"
      title="Stories & articles"
      categories="3,5"
      viewMoreHref="/stories?page=1&categories=3,5"
      viewMoreLabel="All stories"
      fallbackLabel="Story"
      ctaLabel="Read the story"
      tone="ivory"
    />
  );
}

export default React.memo(Publication);
